import appLocaleData from 'react-intl/locale-data/th';

const thLang = {
  messages: {
    ...(window as any).RBH_MESSAGE_TH,
  },
  locale: 'th-TH',
  data: appLocaleData,
};

export default thLang;
